import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=5486cde3&scoped=true&"
import script from "./Surveys.js?vue&type=script&lang=js&"
export * from "./Surveys.js?vue&type=script&lang=js&"
import style0 from "./Surveys.scss?vue&type=style&index=0&id=5486cde3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5486cde3",
  null
  
)

export default component.exports